import {
  IconMute,
  IconPause,
  IconPlay,
  IconUnmute,
} from '@mc/educator-design-system'
import { useTranslation } from '@mc/i18n'
import { useVideo } from '@mc/video'

// Figma 17096:11604 ("Modality Buttons") — 32px square glass shell: no radius,
// fg-ultra-dimmed fill, fg-super-dimmed hairline, 5.876px blur. Same recipe as
// LongformActionBar's glass variant.
const CONTROL_CLASSES =
  'flex size-8 cursor-pointer items-center justify-center border border-edu-fg-super-dimmed bg-edu-fg-ultra-dimmed text-edu-fg-primary backdrop-blur-[6px] transition-colors hover:border-transparent hover:bg-edu-fg-super-dimmed'

/**
 * Play/pause and mute controls for an inline video. Must render as a child of
 * <Video> so it can read playback state from VideoContext.
 */
export const VideoControls = () => {
  const { t } = useTranslation('@mc/educator')
  const { state, muted, togglePlay, toggleMute } = useVideo()

  const isPlaying = state === 'playing'

  return (
    // Figma 17112:31886 — row anchored 24px from the video's right/bottom edges.
    <div className='absolute right-6 bottom-6 z-10 flex items-center gap-3'>
      <button
        type='button'
        className={CONTROL_CLASSES}
        aria-label={isPlaying ? t('video.pause') : t('video.play')}
        onClick={togglePlay}
      >
        {isPlaying ? <IconPause size='sm' /> : <IconPlay size='sm' />}
      </button>
      <button
        type='button'
        className={CONTROL_CLASSES}
        aria-label={muted ? t('video.unmute') : t('video.mute')}
        onClick={toggleMute}
      >
        {/* The EDS media icons are named for the action, not the state:
            IconMute is a speaker with waves (click to mute), IconUnmute is a
            speaker with an X (click to unmute). */}
        {muted ? <IconUnmute size='sm' /> : <IconMute size='sm' />}
      </button>
    </div>
  )
}
